import { put, takeLatest } from "redux-saga/effects";

import {
  complaintAddInSuccess,
  complaintAddInFailure,
} from "./complaint.actions";

import ComplaintType from "./complaint.types";


function* complaintAddInStart(payload) {
  try {
    yield put(complaintAddInSuccess(payload));
  } catch (error) {
    yield put(complaintAddInFailure(error));
  }
}

export default function* complaintSagas() {
  yield takeLatest(ComplaintType.COMPLAINT_START, complaintAddInStart);

}
